/* =========================================================================
   "Theo's 50/50" hint — PURE logic, unit-tested (mirrors dyk.ts). Free once per
   round; the timer keeps ticking (the drain curve already charges for thinking
   time, and pausing would require engine changes + invite a freeze-and-think
   exploit). The controller disables two wrong options via `.hint-out`.
   ========================================================================= */

/** A hint is free but limited to once per round. */
export function hintAllowed(hintUsedThisRound: boolean): boolean {
  return !hintUsedThisRound;
}

/** Theo's 50/50 is introduced gradually: hidden through Round 1 (roundIndex 0)
    so the warm-up round stays simple, then available from Round 2 onward. The
    first time it appears, the controller fires a one-time Theo intro pop. PURE. */
export function hintVisibleFor(roundIndex: number): boolean {
  return roundIndex >= 1;
}

/**
 * Pick up to two WRONG option indices to remove, leaving the correct answer and
 * one distractor. `rand` is injectable for deterministic tests.
 */
export function pickHintRemovals(
  correctIndex: number,
  optionCount: number,
  rand: () => number = Math.random,
): number[] {
  const wrong: number[] = [];
  for (let i = 0; i < optionCount; i++) if (i !== correctIndex) wrong.push(i);
  // Fisher-Yates on the wrong indices, then take two.
  for (let i = wrong.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1));
    [wrong[i], wrong[j]] = [wrong[j], wrong[i]];
  }
  return wrong.slice(0, Math.min(2, wrong.length));
}
